import React from "react";
import styled from "styled-components";

/* Discontinued Typography 
- use components in Link folder
*/
const StyledLinkText = styled.a`
  font-family: ${({ theme }) => theme.fonts.graphik};
  color: ${({ theme, white }) =>
    white ? theme.colors.white : theme.colors.green500};
  font-weight: 500;
  font-size: 1rem;
  line-height: 1.5rem;
  margin: 0;
  text-decoration: none;

  &:hover {
    color: ${({ theme, white }) =>
      white ? theme.colors.white : theme.colors.green600};
    text-decoration: ${({ white }) => (white ? "underline" : "none")};
  }

  &:active {
    color: ${({ theme, white }) =>
      white ? theme.colors.white : theme.colors.green700};
    text-decoration: ${({ white }) => (white ? "underline" : "none")};
  }
`;

const LinkTxt = ({ children, className, white, to }) => {
  return (
    <StyledLinkText
      as={to ? "a" : "span"}
      href={to}
      white={white}
      className={className}
    >
      {children}
    </StyledLinkText>
  );
};

LinkTxt.defaultProps = {
  white: false
};

export default LinkTxt;
